// src/components/pages/Blog.jsx
import React, { useState } from "react";
import {
  Box,
  Container,
  Flex,
  Stack,
  Heading,
  Text,
  Button,
} from "@chakra-ui/react";
import BlogList from "../content/blogs/BlogList";
import TaxReliefForm from "../content/forms/TaxReliefForm";

export default function Blogs() {
  const [showForm, setShowForm] = useState(false);

  const heroOverlay = "rgba(0,0,0,0.55)";
  const heroBg = "/images/casestudy-bg.jpg";
  const cardBg = { base: "white", _dark: "gray.800" };
  const border = { base: "gray.200", _dark: "whiteAlpha.300" };

  return (
    <>
      {/* HERO */}
      <Box
        position="relative"
        bgImage="url('/images/casestudy-bg.jpg')"
        bgSize="cover"
        // ↓ shift y-position so more of the bottom is kept in view
        bgPos={{ base: "center 65%", md: "center 85%" }}
        bgRepeat="no-repeat"
        minH={{ base: "60vh", md: "60vh", lg: "60vh" }}
        _before={{
          content: '""',
          position: "absolute",
          inset: 0,
          bg: heroOverlay,
        }}
      >
        <Container
          maxW="6xl"
          py={{ base: 10, md: 16 }}
          position="relative"
          zIndex={1}
          color="white"
        >
          <Flex
            direction={{ base: "column", lg: "row" }}
            gap={{ base: 8, lg: 12 }}
            align="flex-start"
          >
            {/* Left: Title + blurb + toggle */}
            <Box flex="1" pr={{ lg: 8 }}>
              <Stack spacing={{ base: 4, md: 6 }}>
                <Heading
                  fontSize={{ base: "5xl", md: "7xl", lg: "8xl" }} // bigger
                  lineHeight={{ base: "1.05", md: "1.05" }}
                  fontWeight="800"
                  letterSpacing={{ base: "-0.02em", md: "-0.03em" }}
                  color="white"
                >
                  CASE STUDIES
                </Heading>

                <Text
                  maxW="3xl"
                  fontSize={{ base: "lg", md: "xl", lg: "2xl" }} // bigger blurb
                  opacity={0.9}
                  color="white"
                >
                  How different firms approach specific tax problems—1040
                  balances, unfiled years, payroll 941, and more.
                </Text>

                <Button
                  onClick={() => setShowForm((v) => !v)}
                  size={{ base: "lg", md: "lg" }}
                  px={{ base: 6, md: 8 }}
                  height={{ base: 12, md: 14 }}
                  borderWidth="2px"
                  colorScheme="white" // black outline look
                  alignSelf="start"
                >
                  {showForm
                    ? "Hide form"
                    : "Learn how these companies can help you"}
                </Button>
              </Stack>
            </Box>

            {/* Right: intake form (optional) */}
            {showForm ? (
              <Box
                w={{ base: "100%", lg: "560px", xl: "640px" }}
                bg={cardBg}
                color="gray.800"
                borderRadius="lg"
                p={5}
                boxShadow="lg"
                borderWidth="1px"
                borderColor={border}
              >
                <TaxReliefForm source="blogs-hero" />
              </Box>
            ) : null}
          </Flex>
        </Container>
      </Box>

      {/* MAIN */}
      <Box py={{ base: 10, md: 14 }}>
        <Container maxW="6xl">
          <Stack spacing={6}>
            <Heading size="lg">Featured Case Studies</Heading>
            <BlogList />
          </Stack>
        </Container>
      </Box>
    </>
  );
}
